import { Component } from '@angular/core';
import { ConfirmationDialogComponent } from '../../shared/confirmation-dialog/confirmation-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { CommonService } from 'src/app/services/common/common.service';

@Component({
  selector: 'app-common-layout',
  templateUrl: './common-layout.component.html',
  styleUrls: ['./common-layout.component.scss'],
})
export class CommonLayoutComponent {
  isLogin!: boolean;
  isSidebarCollapsed: boolean = false;

  constructor(
    private _dialog: MatDialog,
    private _commonService: CommonService
  ) {
    if (localStorage.getItem('authToken')) {
      this.isLogin = true;
    }
  }

  ngAfterViewInit() {
    if (this._commonService.isStandardScreenModelOpen)
      this.showPopupRegardingResolution();
  }

  showPopupRegardingResolution() {
    var dialogRef = this._dialog.open(ConfirmationDialogComponent, {
      width: '24.514vw', //353px
      height: '12.083vw',
      data: {
        header: 'Please note',
        data: {
          bodyData: `This application is optimized for standard screen resolutions.`,
        },
        button: {
          isSubmit: true,
          submitbtnText: 'Ok',
          isCancel: false,
          isDelete: false,
          hideAllButtonsLeftSubmit: true,
        },
      },
    });

    dialogRef.disableClose = true;

    dialogRef.afterClosed().subscribe((result: any) => {
      this._commonService.isStandardScreenModelOpen = false;
    });
  }

  onSidebarToggle(value: boolean) {
    this.isSidebarCollapsed = value;
  }
}
